/*
 * Module for categories
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./categoriesView",
  "./categoryList/categoryListModule",
  "./categoryInfo/categoryInfoModule",
], function (
  Marionette,
  Backbone,
  Messenger,
  CategoriesView,
  CategoryListModule,
  CategoryInfoModule,
) {
  var CategoriesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categories";
      this.namespace = options.namespace;
      this.region = options.region;
    },

    show: function (editor) {
      this.layout = new CategoriesView.categoriesLayout();

      this.categoryList = this.addSubModule(
        new CategoryListModule({
          namespace: this.namespace,
          region: this.layout.categoryList,
        }),
      );
      this.categoryValue = this.addSubModule(
        new CategoryInfoModule({
          namespace: this.namespace,
          region: this.layout.categoryValue,
          responseId: editor.responseId,
        }),
      );

      this.showRegion(this.layout);
      this._showSubViews();
    },

    focus() {
      if (this.isOpen && this.categoryList) {
        this.categoryList.focus();
      }
    },

    setSelected: function (categoryId) {
      // if category selected in editor, select that in list, and show value
      if (!_.isUndefined(categoryId)) {
        this.categoryList.setSelected(categoryId);
      }
    },

    _showSubViews: function () {
      this.categoryList.show();
    },
  });

  return CategoriesController;
});
